export function getEntityTypeUrl(entityType: string){
    let urlPart = "";
    if(entityType?.includes("ARCHIV")) urlPart = urlPart + "archiv/"
    if(entityType?.includes("HISTORIE")) urlPart = urlPart + "historie/"
    return urlPart;
}